import { c as _c } from "react/compiler-runtime";
import { getOrigin } from "@website/utils/channel/get-origin";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
type SchemaHotelPagePropertiesType = {
  image: string;
  name: string;
  starRating: number;
  address: string;
  cityTitle?: string;
  addressCountry?: string;
  url?: string;
  priceRange: string;
  offerPrice?: string | number;
  aggregateRating?: {
    ratingValue?: string | number;
    ratingCount?: string | number;
    reviewCount?: string | number;
  };
};
const stringifySchema = (schema: unknown) => JSON.stringify(schema).replaceAll("<", String.raw`\u003c`);
export const SchemaHotelPage = t0 => {
  const $ = _c(16);
  const {
    image,
    name,
    starRating,
    address,
    cityTitle,
    addressCountry,
    url,
    priceRange,
    offerPrice,
    aggregateRating
  } = t0;
  const hasAggregateRating = Number(aggregateRating?.ratingValue) >= 1 && Number(aggregateRating?.ratingCount) > 0;
  const hasOffer = Boolean(url && Number(offerPrice) > 0);
  let t1;
  if ($[0] !== address || $[1] !== addressCountry || $[2] !== aggregateRating?.ratingCount || $[3] !== aggregateRating?.ratingValue || $[4] !== cityTitle || $[5] !== hasAggregateRating || $[6] !== hasOffer || $[7] !== image || $[8] !== name || $[9] !== offerPrice || $[10] !== priceRange || $[11] !== starRating || $[12] !== url) {
    t1 = stringifySchema({
      "@context": "https://schema.org/",
      "@type": "Hotel",
      image,
      name,
      starRating,
      address: {
        "@type": "PostalAddress",
        streetAddress: address,
        ...(cityTitle ? {
          addressLocality: cityTitle
        } : {}),
        ...(addressCountry ? {
          addressCountry
        } : {})
      },
      ...(url ? {
        url
      } : {}),
      priceRange,
      ...(hasAggregateRating ? {
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: `${aggregateRating?.ratingValue}`,
          ratingCount: `${aggregateRating?.ratingCount}`,
          bestRating: "5",
          worstRating: "1"
        }
      } : {}),
      ...(hasOffer ? {
        offers: {
          "@type": "Offer",
          price: `${offerPrice}`,
          priceCurrency: "IRR",
          priceSpecification: {
            "@type": "PriceSpecification",
            price: `${offerPrice}`,
            priceCurrency: "IRR",
            valueAddedTaxIncluded: true
          },
          availability: "https://schema.org/InStock",
          url,
          seller: {
            "@type": "Organization",
            name: replaceSnappTripBasedOnChannel("\u0627\u0633\u0646\u067E \u062A\u0631\u06CC\u067E"),
            url: getOrigin()
          }
        }
      } : {})
    });
    $[0] = address;
    $[1] = addressCountry;
    $[2] = aggregateRating?.ratingCount;
    $[3] = aggregateRating?.ratingValue;
    $[4] = cityTitle;
    $[5] = hasAggregateRating;
    $[6] = hasOffer;
    $[7] = image;
    $[8] = name;
    $[9] = offerPrice;
    $[10] = priceRange;
    $[11] = starRating;
    $[12] = url;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  let t2;
  if ($[14] !== t1) {
    t2 = <script dangerouslySetInnerHTML={{
      __html: t1
    }} type="application/ld+json" />;
    $[14] = t1;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  return t2;
};